<template>
    <v-menu
      :open-on-hover="false"
    >
      <template v-slot:activator="{ on: menu }">
        <v-tooltip v-model="show" bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn v-on="{ ...tooltip, ...menu }" :color="'white'" class="ma-2" text icon >
                <v-icon small>mdi-dots-vertical</v-icon>
            </v-btn>               
          </template>
          <span>Stock Menu</span>
        </v-tooltip>
      </template>

      <v-list>
        <v-subheader>{{(title != null ? title : stock)}}</v-subheader>
        <v-list-item :to="'/stocks/analyze/' + stock">
          <v-list-item-title>    
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon color="primary" v-on="on" :to="'/stocks/analyze/' + stock"  >
                  <v-icon >mdi-magnify-plus-outline</v-icon>
                </v-btn>     
                Analyze stock
              </template>                      
              <span>Analyze</span>
            </v-tooltip>                                   
            </v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-title><stock-set-preference :stock="stock" :rating="preference"></stock-set-preference>Rate the stock</v-list-item-title>                      
        </v-list-item>
        <v-list-item>
          <v-list-item-title><stock-potential-replacement :stock="stock" ></stock-potential-replacement>Check similar stocks</v-list-item-title>
        </v-list-item>                              
      </v-list>

    </v-menu>

</template>

<script>
export default {
  name: "StockMenu",
  props: {
    stock: String,
    preference: Number,
    title: String,
  },
  components: {
    StockPotentialReplacement: () => import('@/components/StockPotentialReplacement'),
    StockSetPreference: () => import('@/components/SetPreferences'),      
  },
  data() {
    return {
      show:false
    };
  }
};
</script>